module.exports = "images/miscellaneous_view_point.d0d4e0549951105db5de24c354395f2b.png";